import { combineReducers } from 'redux-immutable'
import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import dataReducer from './data'
import wpReducerFactory from './wpReducerFactory';


const INIT_STATE = Map();


const pagesReducer = wpReducerFactory(
    actionTypes.WP_PAGES_GET_REQUEST, 
    actionTypes.WP_PAGES_GET_SUCCESS, 
    actionTypes.WP_PAGES_GET_ERROR
)

const servicePagesReducer = wpReducerFactory(
    actionTypes.WP_SERVICEPAGES_GET_REQUEST, 
    actionTypes.WP_SERVICEPAGES_GET_SUCCESS, 
    actionTypes.WP_SERVICEPAGES_GET_ERROR
)

const menuItemsReducer = wpReducerFactory(
    actionTypes.WP_MENUITEMS_GET_REQUEST, 
    actionTypes.WP_MENUITEMS_GET_SUCCESS, 
    actionTypes.WP_MENUITEMS_GET_ERROR
)

const combinedReducer = combineReducers({
    pages: pagesReducer,
    servicePages: servicePagesReducer,
    menuItems: menuItemsReducer,
    data: dataReducer
});

const wpServerDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default wpServerDataReducer;